export default __webpack_public_path__ + "static/media/notification.d3262cf7.svg";